// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AG xm","wrapperNeon":"AH xy","ribbon":"AI xv","title":"AJ xo","seasons":"AK xt","genres":"AL xu","buttonWrapper":"AM xq","button":"AN xr","buttonNeon":"AO xz"};